export default (onValue, offValue, display, state = false) => ({

    state: state,
    display: display,
    onValue: onValue,
    offValue: offValue,

    toggleItem() {
        this.state = !this.state;
    },

    get value() {
        return this.state ? onValue : offValue;
    },
});
